const TypeRequestedFlow = {
  save: "SAVE",
  solicitation: "SOLICITATION",
  update: "UPDATE",
  delete: "DELETE"
};

export default TypeRequestedFlow;
